import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from './../../../utils/styles'

import styles from './Label.scss'

export default function Label({ children, id, hidden }) {
  const className = classNames(styles.Label, hidden && styles.hidden)

  return (
    <div className={className}>
      <label id={labelID(id)} htmlFor={id} className={styles.Text}>
        {children}
      </label>
    </div>
  )
}

export function labelID(id) {
  return `${id}Label`
}

Label.propTypes = {
  children: PropTypes.any,
  id: PropTypes.string,
  hidden: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Form/Label/index.js